import { useHearts } from 'src/hook/data/useHearts';
import usePopUp from 'src/hook/modal/usePopUp';
import { HeartType } from 'src/model/enum/enums';
import { IconLocation } from 'src/utils/URLUtils';
import styles from './HeartPopUp.module.scss';

interface HeartPopUpProps {
    heartType: HeartType;
}

const HeartPopUp = ({ heartType }: HeartPopUpProps) => {
    const { hide } = usePopUp();
    const { getHeartText, getHeartCount } = useHearts();
    return (
        <div className={styles.heartPopUp}>
            <img className='LgIcon' src={IconLocation('heart')} alt="heart" />
            <h2>{getHeartCount(heartType)}</h2>
            <h2>Hearts refilled!</h2>
            <p>{getHeartText(heartType)}</p>
            <button onClick={hide}>Awsome</button>
        </div>

    );
};

export default HeartPopUp;